export default "__VITE_PUBLIC_ASSET__cf751b42__"